import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';
export default function AboutSection() {
    const sectionRef = useRef(null);
    const [videoModalOpen, setVideoModalOpen] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.querySelectorAll('.reveal-up').forEach((el) => {
                        el.classList.add('revealed');
                    });
                    entry.target.querySelectorAll('.reveal-fade').forEach((el) => {
                        el.classList.add('revealed');
                    });
                }
            });
        }, { threshold: 0.15 });
        if (sectionRef?.current)
            observer?.observe(sectionRef?.current);
        return () => observer?.disconnect();
    }, []);
    return (<>
      <section ref={sectionRef} id="about" className="bg-secondary py-16 lg:py-20 border-t border-border/40 scroll-mt-24" aria-label="About Awakasha Entertainment">

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Left: Text Content */}
            <div className="flex flex-col gap-6">
              <div className="reveal-up">
                <p className="section-label mb-3">About Awakasha</p>
                <h2 className="font-display text-section-title font-semibold text-foreground leading-tight gold-underline">
                  Unique Experiences for<br />
                  Sri Lankans in Australia
                </h2>
              </div>


              <div className="reveal-up space-y-4" style={{ transitionDelay: '150ms' }}>
                <p className="text-muted-foreground leading-relaxed text-base">
                  Awakasha Entertainment is dedicated to providing unique and innovative experiences for the Sri Lankan community in Australia.
                </p>
                <p className="text-muted-foreground leading-relaxed text-base">
                  Constantly exploring new ideas and creative approaches to stand out in the entertainment industry. Committed to redefining the industry by offering exciting and memorable experiences. Dedicated to setting ourselves apart from competitors.
                </p>
                <p className="text-muted-foreground leading-relaxed text-base">
                  At Awakasha Entertainment, we invite Sri Lankan artists to create unforgettable events for the Sri Lankan community in Australia. Join us to showcase your talent, connect with audiences, and leave a lasting impression. Contact us today!
                </p>
              </div>

              {/* Stats Row */}
              <div className="reveal-up grid grid-cols-3 gap-4 py-5 border-y border-border/40" style={{ transitionDelay: '200ms' }}>
                {[
            { value: '50+', label: 'Events Hosted' },
            { value: '30K+', label: 'Happy Attendees' },
            { value: '3+', label: 'Years of Excellence' }
        ]?.
            map((stat) => <div key={stat?.label} className="text-center">
                    <p className="font-display text-2xl sm:text-3xl font-bold text-primary">{stat?.value}</p>
                    <p className="text-xs text-muted-foreground mt-1 leading-tight">{stat?.label}</p>
                  </div>)}
              </div>

              <div className="reveal-up" style={{ transitionDelay: '250ms' }}>
                <Link to="/contact" className="btn-outline-gold inline-flex items-center gap-2.5 px-6 py-3 rounded-full text-sm">

                  <span>Learn More About Us</span>
                  <Icon name="ArrowRightIcon" size={14}/>
                </Link>
              </div>
            </div>

            {/* Right: Video Thumbnail */}
            <div className="reveal-fade relative" style={{ transitionDelay: '200ms' }}>
              <div className="relative rounded-2xl overflow-hidden aspect-video shadow-2xl shadow-black/50 border border-border/40 group cursor-pointer" onClick={() => setVideoModalOpen(true)} role="button" tabIndex={0} aria-label="Play Awakasha Entertainment video" onKeyDown={(e) => e?.key === 'Enter' && setVideoModalOpen(true)}>

                <AppImage src="/assets/images/dfdfdf-1787489709792.jpg" alt="Massive concert crowd with raised hands, vibrant golden and amber stage lighting, electric atmosphere, dark stadium interior" fill sizes="(max-width: 1024px) 100vw, 50vw" className="object-cover object-center group-hover:scale-105 transition-transform duration-700"/>

                {/* Dark scrim */}
                <div className="absolute inset-0 bg-black/45 group-hover:bg-black/30 transition-colors duration-500"/>

                {/* Play Button */}
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                  <div className="w-20 h-20 rounded-full bg-white/20 backdrop-blur-sm border-2 border-white/70 flex items-center justify-center group-hover:scale-110 group-hover:bg-white/30 transition-all duration-300 shadow-lg">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-9 h-9 ml-1" aria-hidden="true">
                      <path d="M8 5v14l11-7z"/>
                    </svg>
                  </div>
                </div>

              </div>

              {/* Decorative glow */}
              <div className="absolute -bottom-6 -right-6 w-48 h-48 rounded-full pointer-events-none" style={{
            background: 'radial-gradient(circle, rgba(200,146,42,0.15) 0%, transparent 70%)'
        }} aria-hidden="true"/>

            </div>
          </div>
        </div>
      </section>
      {/* Video Modal */}
      {videoModalOpen &&
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 backdrop-blur-sm" onClick={() => setVideoModalOpen(false)} role="dialog" aria-modal="true" aria-label="Video player">

          <div className="relative w-full max-w-4xl mx-4 aspect-video bg-black rounded-xl overflow-hidden shadow-2xl" onClick={(e) => e?.stopPropagation()}>

            <iframe src="https://www.youtube.com/embed/s9kep4mLfj0?autoplay=1" title="Awakasha Entertainment Video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full"/>
            <button onClick={() => setVideoModalOpen(false)} className="absolute top-4 right-4 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors" aria-label="Close video">

              <Icon name="XMarkIcon" size={18}/>
            </button>
          </div>
        </div>}
    </>);
}
